import React, { useEffect, useState } from "react";
import Cookies from "universal-cookie";
import MobileUploaderFirstPage from "./MobileUploaderFirstPage.js";
import MobileUploaderSecondPage from "./MobileUploaderSecondPage.js";
import MobileUploaderSwapElement from "./MobileUploaderSwapElement.js";
import { useContent } from "contexts/contentContext/contentContext.js";

import "./mobileUploader.scss";

const cookies = new Cookies();

const MobileUploaderContainer = () => {
  const [currentRecipients, setCurrentRecipients] = useState(null);
  const { getBlackFridayTimeCookie, setBlackFridayTimeCookie } = useContent();

  const hideHeader = () => {
    document.getElementsByTagName("nav")[0].style.display = "none";
  };

  useEffect(() => {
    hideHeader();
    document.addEventListener("scroll", hideHeader);
    // fixing height of container
    // removing content of home page
    const homeContent = document.querySelector(".home-content");
    const thankyouBtn = document.getElementById("thankYouButton");
    const footer = document.querySelector(".footer-container");
    if (homeContent) homeContent.style.display = "none";
    if (footer) footer.style.display = "none";
    if (thankyouBtn) thankyouBtn.style.display = "none";
    const withBlackFriday = getBlackFridayTimeCookie();
    if (withBlackFriday) {
      cookies.set("BlackFridayModal", new Date().toLocaleDateString());
      setBlackFridayTimeCookie(false);
    }
    // removing the event listener and the class when component unmounts to prevent memory leaks
    return () => {
      if (withBlackFriday) {
        cookies.remove("BlackFridayModal", new Date().toLocaleDateString());
        setBlackFridayTimeCookie(true);
      }
      homeContent.style.display = "block";
      footer.style.display = "flex";
      thankyouBtn.style.display = "flex";
      document.removeEventListener("scroll", hideHeader);
      document.body.classList.remove("stop-scroll");
      document.getElementsByTagName("nav")[0].style.display = "inherit";
    };
  }, []);

  return (
    <div className="mobile-uploader-wrapper">
      <MobileUploaderFirstPage />
      <MobileUploaderSwapElement currentRecipients={currentRecipients} />
      <MobileUploaderSecondPage setCurrentRecipients={setCurrentRecipients} />
    </div>
  );
};
export default MobileUploaderContainer;
